import React, { useState } from "react";
import AddAgent from "../helpers/agentTabs/addAgent";
import ManageAgent from "../helpers/agentTabs/manageAgent";

const Agents = () => {
  const [selectedTab, setSelectedTab] = useState(0);

  const tabItems = [{ label: "Add Agent" }, { label: "Manage Agent" }];

  return (
    <div className="">
      <section className="flex px-8 mt-6 mb-2 gap-6">
        {tabItems.map((tab, index) => (
          <p
            key={index}
            className={`bg-[#fff] py-2 px-6 rounded-full text-center font-outfit text-sm font-medium leading-normal tracking-tighter cursor-pointer border ${
              selectedTab === index ? "border-[#88087B]" : ""
            }`}
            onClick={() => setSelectedTab(index)}
          >
            {tab.label}{" "}
          </p>
        ))}
      </section>

      <main className="px-2 lg:px-4">
        {selectedTab === 0 && <AddAgent />}
        {selectedTab === 1 && <ManageAgent />}
      </main>
    </div>
  );
};

export default Agents;
